import moment from 'moment';

export const formatChartDate = (dateString, interval) => {
  if (!dateString) return dateString;

  const date = moment(dateString, moment.ISO_8601);

  if (interval === 'daily' || interval === 'weekly') {
    return date.format('D ddd'); // D for day, ddd for weekday
  } else if (interval === 'monthly') {
    return date.format(date.isSame(moment(), 'year') ? 'MMM' : 'MMM YY');
  }

  return dateString;
};

export function compareCounts({ prevCount, currentCount, interval }) {
  // Calculate percentage change
  let percentageChange =
    ((currentCount - prevCount) / (prevCount === 0 ? 1 : prevCount)) * 100;

  // Determine the color based on the change
  let color = percentageChange >= 0 ? '#00BC7E' : '#cf3820';

  // Determine the rotation value
  let rotation = percentageChange >= 0 ? 180 : 0;

  // Construct the rateText based on the interval
  let intervalText;
  switch (interval) {
    case 'daily':
      intervalText = 'from yesterday';
      break;
    case 'weekly':
      intervalText = 'from last week';
      break;
    case 'monthly':
      intervalText = 'from last month';
      break;
    default:
      intervalText = 'from previous period';
  }

  // Construct the result object
  return {
    color,
    count: currentCount,
    percentage: percentageChange,
    rotation,
    changeRate: `${percentageChange.toFixed(2)}% ${intervalText}`,
  };
}

// Utility function
export function transformDataForFunnel(data, funnelLabelMap) {
  const allZero = Object.values(data).every((value) => value === 0);
  if (allZero) {
    return null;
  }

  const transformedData = Object.keys(funnelLabelMap).map((key) => ({
    x: funnelLabelMap[key],
    y: data?.[key] || 0,
  }));

  return transformedData;
}

// UUID validation function
export function isValidUUID(id) {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
}

export function getInitials(title) {
  if (!title || typeof title !== 'string') return ''; // Return empty string for falsy or non-string values

  const words = title.split(' ').filter((word) => word.trim().length > 0); // Remove empty words or extra spaces

  // Get initials of the first two words, or fewer if less than two words are present
  const initials = words
    .slice(0, 2) // Take only the first two words
    .map((word) => word[0].toUpperCase()) // Get the first letter and convert to uppercase
    .join(''); // Join the initials together

  return initials;
}

export const toTitleCase = (value = '') => {
  return value
    .toString()
    .replace(/[_-]+/g, ' ')
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
